// Types
import Strategy from "app/types/Strategy";
// Actions
import MixpanelActions from "app/features/mixpanel/MixpanelActions";
// Strategies
import {
  handleCaseEpisodeUpdateConflictStrategy,
  handleCasePageUpdateConflictStrategy,
  handleCaseWorkspaceSwitchToEpisodeViewStrategy,
  handleCaseWorkspaceSwitchToPagesViewStrategy,
  handleCaseWorkspaceSendToAIChatStrategy,
  handleCaseDocumentFocusModeEnterStrategy,
  handleCaseWorkspaceFocusModeEnterStrategy,
  handleCaseEpisodesViewStrategy,
  handleCaseAuditLogViewStrategy,
  handleCaseTemplatesViewStrategy,
  handleCaseWorkflowsViewStrategy,
  handleCaseDocumentsNavBarOpenedStrategy,
  handleCaseDocumentsNavBarClosedStrategy,
  handleCasePagesBulkActionClickStrategy,
  handleCasePagesSwitchToNewDesignStrategy,
  handleCasePagesSwitchToOldDesignStrategy,
  handleCaseReportPreviewOpenedClickStrategy,
  handleCaseDocumentCreatedStrategy,
  handleCaseDocumentDeletedStrategy
} from "app/features/mixpanel/MixpanelStrategies/Case.strategies";

const CaseStrategyMap:Record<string, Strategy> = {
  [MixpanelActions.handleCaseEpisodeUpdateConflict.type]: handleCaseEpisodeUpdateConflictStrategy,
  [MixpanelActions.handleCasePageUpdateConflict.type]: handleCasePageUpdateConflictStrategy,
  [MixpanelActions.handleCaseWorkspaceSwitchToEpisodeViewClick.type]: handleCaseWorkspaceSwitchToEpisodeViewStrategy,
  [MixpanelActions.handleCaseWorkspaceSwitchToPagesViewClick.type]: handleCaseWorkspaceSwitchToPagesViewStrategy,
  [MixpanelActions.handleCaseWorkspaceSendToAIChatClick.type]: handleCaseWorkspaceSendToAIChatStrategy,
  [MixpanelActions.handleCaseDocumentFocusModeEnterClick.type]: handleCaseDocumentFocusModeEnterStrategy,
  [MixpanelActions.handleCaseWorkspaceFocusModeEnterClick.type]: handleCaseWorkspaceFocusModeEnterStrategy,
  [MixpanelActions.handleCaseEpisodesViewClick.type]: handleCaseEpisodesViewStrategy,
  [MixpanelActions.handleCaseAuditLogViewClick.type]: handleCaseAuditLogViewStrategy,
  [MixpanelActions.handleCaseWorkflowsViewClick.type]: handleCaseWorkflowsViewStrategy,
  [MixpanelActions.handleCaseTemplatesViewClick.type]: handleCaseTemplatesViewStrategy,
  [MixpanelActions.handleCaseDocumentsNavBarOpenedClick.type]: handleCaseDocumentsNavBarOpenedStrategy,
  [MixpanelActions.handleCaseDocumentsNavBarClosedClick.type]: handleCaseDocumentsNavBarClosedStrategy,
  [MixpanelActions.handleCasePagesBulkActionClick.type]: handleCasePagesBulkActionClickStrategy,
  [MixpanelActions.handleCasePagesSwitchToNewDesignClick.type]: handleCasePagesSwitchToNewDesignStrategy,
  [MixpanelActions.handleCasePagesSwitchToOldDesignClick.type]: handleCasePagesSwitchToOldDesignStrategy,
  [MixpanelActions.handleCaseReportPreviewOpenedClick.type]: handleCaseReportPreviewOpenedClickStrategy,
  [MixpanelActions.handleCaseDocumentCreatedClick.type]: handleCaseDocumentCreatedStrategy,
  [MixpanelActions.handleCaseDocumentDeletedClick.type]: handleCaseDocumentDeletedStrategy,
};

export default CaseStrategyMap;
